import { render, staticRenderFns } from "./form-newsletter.vue?vue&type=template&id=5ea5f1dc&"
import script from "./form-newsletter.vue?vue&type=script&lang=js&"
export * from "./form-newsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports